import React from 'react';

const COLOR_TAG_RE = /\{#([0-9A-Fa-f]{6}):([^}]+)\}/g;

export function stripColorTags(text: string | undefined): string {
  if (!text) return '';
  return text.replace(COLOR_TAG_RE, '$2');
}

/**
 * Parses a string containing `{#hex:text}` color tags and returns React nodes.
 *
 * Plain segments inherit the parent's color; tagged segments render in the
 * specified hex color. Multiple tags per string are supported.
 *
 * @example
 * parseColoredText('Earn {#FBBF24:1 point per hour} while hosting.')
 * // → ["Earn ", <span style={{color:'#FBBF24'}}>1 point per hour</span>, " while hosting."]
 */
export function parseColoredText(text: string | undefined): React.ReactNode {
  if (!text) return null;

  const nodes: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let key = 0;

  COLOR_TAG_RE.lastIndex = 0;

  while ((match = COLOR_TAG_RE.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }
    nodes.push(
      <span key={key++} style={{ color: `#${match[1]}` }}>
        {match[2]}
      </span>,
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes.length === 1 ? nodes[0] : <>{nodes}</>;
}
